import React, { useEffect } from "react";
import { getLastMonday, getNextSunday, getTodayString, parseDate } from "../../../functions/date";
import WeekView from "../WeekView/WeekView";
import { FormattedEvent } from "../../../types";
import WeekHeader from "../WeekHeader/WeekHeader";
import './WeekViewPage.css'

interface WeekViewPageProps {
  events?: FormattedEvent[];
  day: string; // current day passed from parent
  onChangeDay: (newDay: string) => void; // callback to update day
}

const WeekViewPage: React.FC<WeekViewPageProps> = ({ events = [], day, onChangeDay }) => {
  // Parse the provided day, or default to today
  const parsedDate = parseDate(day) ?? parseDate(getTodayString());
  const baseDate = parsedDate ?? new Date();

  // Calculate week start (Monday) and end (Sunday)
  const weekStart = getLastMonday(baseDate);
  const weekEnd = getNextSunday(baseDate);
  
  // Handlers for navigation
  const goToCurrentWeek = () => {
    goToWeek(new Date(), 0)
  };

  const goToPreviousWeek = () => {
    goToWeek(weekStart, -1)
  };

  const goToNextWeek = () => {
    goToWeek(weekStart, 1)
  };

  const goToSpecificWeek = (startDate: Date) => {
    goToWeek(startDate, 0)
  }

  const goToWeek = (startDate: Date, offset: number) => {
    const d = new Date(startDate);
    d.setDate(d.getDate() + offset * 7);
    const str = `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    onChangeDay(str);
  }

  return (
    <div className="WeekViewPage">
      <WeekHeader
        startDate={weekStart}
        endDate={weekEnd}
        onPrevWeek={goToPreviousWeek}
        onNextWeek={goToNextWeek}
      />
      <WeekView events={events} startDate={weekStart} onGoToSpecificWeek={(date) => goToSpecificWeek(date)} />
    </div>
  );
};

export default WeekViewPage;